module.exports = __webpack_public_path__ + "img/icon-success.61cefc33.png";